import { Dialog } from '@mui/material';
import styled from 'styled-components';

export const StyledDialog = styled(Dialog)`
  && .MuiDialog-paper {
    margin: 1rem 2rem;
    max-height: 99vh;
  }

  && .MuiDialogTitle-root {
    padding: 0.65rem 1rem;
    font-weight: 600;
  }

  && .MuiDialogContent-root {
    padding: 1rem 1.5rem;
    min-width: 400px;
  }

  && .MuiDialogActions-root {
    padding: 0.75rem 1.5rem;
  }
`;
